angular.module('elfium').service('taskService', ['$q', '$uibModal', 'elfiumRestService', 'elfiumUrlService', 'elfiumConvertFieldTypesFilter', 'elfiumPreSaveFilter', 'TASK_FIELD_TYPES', 
    function ($q, $uibModal, elfiumRestService, elfiumUrlService, elfiumConvertFieldTypesFilter, elfiumPreSaveFilter, TASK_FIELD_TYPES) {
        var that = this;
        that.getTasks = function ()  {
            return elfiumRestService.getTasks().then(that._convertFieldTypes);
        };
        that.getTasksBetweenDates = function (dateFrom, dateTo) {
            var searchParameters = {
                termin: {
                    between: {
                        valueFrom: dateFrom,
                        valueTo: dateTo
                    }
                }
            };
            return elfiumRestService.searchTasks(searchParameters).then(that._convertFieldTypes);
        };
        that.getTask = function (taskId)  {
            return elfiumRestService.getTask(taskId).then(that._convertFieldTypes);
        };
        that.searchTasks = function (searchParameters) {
            return elfiumRestService.searchTasks(searchParameters).then(that._convertFieldTypes);
        };
        that.upsertTask = function (task) {
            var filteredTask = elfiumPreSaveFilter(TASK_FIELD_TYPES, task);
            if (filteredTask.id) {
                return elfiumRestService.updateTask(filteredTask);
            } else {
                return elfiumRestService.createTask(filteredTask);
            }
        };
        that._convertFieldTypes = function (tasks) {
            return $q.when(elfiumConvertFieldTypesFilter(TASK_FIELD_TYPES, tasks));
        };
        that.newTaskForBusinessCaseDetailModal = function (businessCaseId) {
            return that.openTaskDetailModal(null, businessCaseId);
        };
        that.shouldCreateNewTaskModal = function () {
            return $uibModal.open({
                templateUrl: elfiumUrlService.getTemplateUrl('task', 'taskCreateNewModal'),
                size: 'sm'
            }).result;
        };
        that.openTaskDetailModal = function (taskId, businessCaseId, taskData) {
            taskData = taskData || {};
            var modalInstance = $uibModal.open({
                templateUrl:  elfiumUrlService.getTemplateUrl('task', 'taskDetailModal'),
                controller: 'taskDetailModalController',
                resolve: {
                    taskId: function () {
                        return taskId;
                    },
                    businessCaseId: function () {
                        return businessCaseId;
                    },
                    taskData: function () {
                        return taskData;
                    }
                }
            });
            return modalInstance.result;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskService.ts